export default {
  title: '数据报表',
  salesReport: '销售报表',
};
